import React from 'react'
import { Fade } from 'react-awesome-reveal'

function Banner() {
  return (
    <div className="section-banner bg-market">
      <img src="assets/img/theme/banner-theme-1.png" alt="banner-theme-2" className="banner-theme-1" />
      <img src="assets/img/theme/banner-theme-2.png" alt="banner-theme-2" className="banner-theme-2" />
      <img src="assets/img/theme/banner-theme-2.png" alt="banner-theme-3" className="banner-theme-3" />
      <div className="container">
        <div className="row">
          <Fade triggerOnce duration={1000} direction='up' className="col-lg-6 col-sm-12">
            <div className="hero-content">
              <div className="banner-main">
                <div className="zx-app-banner">
                  <img src="assets/img/theme/theme_1.png" alt="theme_1" className="theme_1" />
                  <h1>Get <span>Benefit</span> By Using Trending AI App</h1>
                </div>
                <div className="zx-app-paragraph">
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Temporibus non perspiciatis Eos eius nostrum consectetur in
                    non?
                  </p>
                </div>
                <div className="zx-app-reviews">
                  <button type="submit" className="zx-app-buttons">Click here</button>
                  <div className="reviews-inner">
                    <h4>15K Reviews</h4>
                  </div>
                  <div className="zx-app-icons">
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                  </div>
                  <img src="assets/img/theme/theme_2.png" alt="theme_2" className="theme_2" />
                </div>
                <div className="zx-app-rounded">
                  <img src="assets/img/testimonials/1.jpg" alt="reviews" />
                  <img src="assets/img/testimonials/2.jpg" alt="reviews" />
                  <img src="assets/img/testimonials/3.jpg" alt="reviews" />
                  <img src="assets/img/testimonials/4.jpg" alt="reviews" />
                </div>
              </div>
            </div>
          </Fade>
          <Fade triggerOnce duration={1500} direction='up' className="col-lg-6 col-sm-12">
            <div className="hero-content-img">
              <img src="assets/img/theme/plus.png" alt="plus" className="plus-effcat" />
              <img src="assets/img/theme/theme_3.png" alt="theme_3" className="theme_3" />
              <img src="assets/img/services/services_page.png" alt="services_page" className="hero_image" />
            </div>
          </Fade>
        </div>
      </div>
    </div>
  )
}

export default Banner
